module.exports = __webpack_public_path__ + "img/p1-device.5af30e28.png";